var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 83.172,
    rx: 22,
    fill: "url(#paint0_linear_128_39)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7891 60.244L21.7813 60.2439C12.8241 60.1584 5.63216 52.8279 5.71764 43.8707L5.74567 40.9332C5.83115 31.976 13.1617 24.784 22.1189 24.8695L22.1267 24.8696C31.0839 24.955 38.2758 32.2856 38.1904 41.2428L38.1623 44.1803C38.0768 53.1375 30.7463 60.3295 21.7891 60.244Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9119 52.9123C17.8775 52.8738 14.6513 48.1943 14.706 42.4603C14.7607 36.7263 18.0756 32.1092 22.11 32.1477C26.1444 32.1862 29.3706 36.8657 29.3158 42.5997C29.2611 48.3337 25.9462 52.9508 21.9119 52.9123Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8102 30.8207L22.514 39.0536L13.0014 37.4007L19.8102 30.8207Z",
    fill: "#FFFBF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5967 60.244L63.5889 60.2439C54.6317 60.1584 47.4398 52.8279 47.5253 43.8707L47.5533 40.9332C47.6388 31.976 54.9693 24.784 63.9265 24.8695L63.9343 24.8696C72.8915 24.955 80.0835 32.2856 79.998 41.2428L79.9699 44.1803C79.8845 53.1375 72.5539 60.3295 63.5967 60.244Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7197 52.9123C59.6853 52.8738 56.4592 48.1943 56.5139 42.4603C56.5686 36.7263 59.8835 32.1092 63.9179 32.1477C67.9523 32.1862 71.1784 36.8657 71.1237 42.5997C71.069 48.3337 67.7541 52.9508 63.7197 52.9123Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6181 30.8207L64.3218 39.0536L54.8093 37.4007L61.6181 30.8207Z",
    fill: "#FFFBF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80288 12.8502L22.5726 10.7605C25.0463 10.3557 27.3798 12.0329 27.7846 14.5066L27.9591 15.5726C28.3639 18.0463 26.6867 20.3798 24.213 20.7846L11.4433 22.8743C8.96957 23.2791 6.6361 21.6019 6.2313 19.1282L6.05684 18.0622C5.65204 15.5885 7.3292 13.255 9.80288 12.8502Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9509 12.8503L63.1811 10.7606C60.7075 10.3558 58.374 12.0329 57.9692 14.5066L57.7947 15.5727C57.3899 18.0464 59.0671 20.3798 61.5408 20.7846L74.3105 22.8743C76.7842 23.2791 79.1177 21.602 79.5225 19.1283L79.6969 18.0622C80.1017 15.5885 78.4246 13.2551 75.9509 12.8503Z",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.253 70.7438C33.9271 70.7438 31.4805 64.6579 31.5718 61.8091H53.482C53.482 64.1399 52.6604 70.7438 42.253 70.7438Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5268 51.5147C32.229 51.5147 28.0113 57.6007 27.1897 60.6437L42.8007 64.3341L58.4118 60.6437C57.4075 57.6007 52.8246 51.5147 42.5268 51.5147Z",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_128_39",
    x1: 42.5,
    y1: 0,
    x2: 42.5,
    y2: 83.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7979F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5BD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2eed62a9dbb8bf1030b3f14be451f4b4.svg";
export { ForwardRef as ReactComponent };